import { render, staticRenderFns } from "./DIconPreviewVideo.vue?vue&type=template&id=230ff60f&scoped=true&"
import script from "./DIconPreviewVideo.vue?vue&type=script&lang=js&"
export * from "./DIconPreviewVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230ff60f",
  null
  
)

export default component.exports